import React, { useEffect, useRef } from 'react';
import Icon from '@mdi/react';
import { mdiCheckDecagram } from '@mdi/js';
import '../styles/style.css';
import '../styles/mediaqueries.css';

const backendSkills = [
    { name: 'FastAPI',       level: 'Intermediate', pct: 0.70 },
    { name: 'Docker',      level: 'Advanced', pct: 0.95 },
    { name: 'RabbitMQ',    level: 'Intermediate', pct: 0.65 },
    { name: 'Kubernetes',  level: 'Basic',        pct: 0.40 },
    { name: 'JavaScript',  level: 'Basic',        pct: 0.45 },
    { name: 'PostgreSQL',       level: 'Intermediate', pct: 0.70 },
];

const generalSkills = [
    { name: 'Python',      level: 'Intermediate', pct: 0.75 },
    { name: 'Flutter',     level: 'Intermediate', pct: 0.68 },
    { name: 'MongoDB',     level: 'Intermediate', pct: 0.65 },
    { name: 'Git',         level: 'Intermediate', pct: 0.72 },
    { name: 'Linux',       level: 'Intermediate', pct: 0.72 },
    { name: 'C#',          level: 'Intermediate', pct: 0.60 },
];

function SkillPanel({ title, badge, skills }) {
    return (
        <div className="details-container fade-up">
            <h2 className="experience-sub-title">
                {title}
                <span className="badge">{badge}</span>
            </h2>
            <div className="article-container">
                {skills.map(({ name, level, pct }) => (
                    <article key={name}>
                        <Icon
                            path={mdiCheckDecagram}
                            size={0.9}
                            color="var(--spark)"
                            aria-hidden="true"
                            style={{ flexShrink: 0 }}
                        />
                        <div style={{ flex: 1 }}>
                            <h3>{name}</h3>
                            <p>{level}</p>
                            <div className="skill-bar-wrap">
                                <div
                                    className="skill-bar-fill"
                                    data-pct={pct}
                                    style={{ transform: `scaleX(0)` }}
                                />
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}

function Experience() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Fade up cards
                        entry.target.querySelectorAll('.fade-up').forEach(el => {
                            el.classList.add('visible');
                        });

                        // Animate skill bars with slight delay
                        setTimeout(() => {
                            entry.target.querySelectorAll('.skill-bar-fill').forEach(bar => {
                                const pct = parseFloat(bar.dataset.pct);
                                bar.style.transform = `scaleX(${pct})`;
                            });
                        }, 300);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="experience" ref={sectionRef}>
            <div className="scan-line" />

            <p className="section__text__p1">Explore My</p>
            <h1 className="title">Skills & Tools</h1>

            <div className="experience-details-container">
                <div className="about-containers">
                    <SkillPanel
                        title="Backend Development"
                        badge="Core"
                        skills={backendSkills}
                    />
                    <SkillPanel
                        title="General & Mobile"
                        badge="Broad"
                        skills={generalSkills}
                    />
                </div>
            </div>
        </section>
    );
}

export default Experience;